import type { AnalyticsClient } from '@3plearning/mx-teacher-analytics';
import { useTimeOnPage } from '@3plearning/mx-teacher-analytics/react';
import {
    useEffect, useRef
} from 'react';

import type { AppEvents } from './events';
import { useAnalyticsClient } from './use-analytics-client';
import { useAnalyticsIdentity } from './use-analytics-identity';

const usePageTracking = () => {
    const client = useAnalyticsClient();
    const previousPathRef = useRef<string | null>(null);

    useEffect(() => {
        if (!client) return;

        // Single page module, no router — the path is fixed for the session,
        // so this fires once and the ref guards a repeat.
        const currentPath = window.location.pathname;

        if (previousPathRef.current === currentPath) return;

        client.track('page.view', {});
        client.trackSession(currentPath);
        previousPathRef.current = currentPath;
    }, [client]);
};

const TimeOnPageTracker = ({ client }: { client: AnalyticsClient<AppEvents> }) => {
    useTimeOnPage(client);

    return null;
};

export const AnalyticsListener = () => {
    const client = useAnalyticsClient();

    useAnalyticsIdentity();
    usePageTracking();

    if (!client) return null;

    return <TimeOnPageTracker client={client} />;
};
